<template>
  <div id="dashboard-analytics" class="w-full">
    <div class="container">
      <div class="mx-auto lg:w-5/12 md:w-8/12 w-full bg-white">
        <div class="wrapper">
          <img
            src="../../../assets/images/logo/avajanglogo.jpg"
            class="img-responsive"
          />
          <form action="" method="post" class="mx-2">
            <div class="flex">
              <label class="label_submit w-full py-4 bg-info"
                >فرم ثبت‌نام</label
              >
            </div>
            <div class="w-full mt-4">
              <div class="my-2">
                <label for="userName">نام کاربری:</label>
              </div>
              <div class="flex">
                <input
                  v-model="model.username"
                  class="Password p-3 w-full"
                  type="text"
                  placeholder="نام کاربری خود را وارد کنید"
                />
              </div>
            </div>
            <div class="w-full my-4">
              <div class="my-2">
                <label for="password">کلمه عبور:</label>
              </div>
              <div class="flex Password">
                <input
                  v-model="password"
                  class="Password p-4 w-full bg-danger"
                  :type="isShowPassword ? 'text' : 'password'"
                  placeholder="کلمه عبور خود را وارد کنید"
                  id="Password_input"
                />
                <i
                  v-if="isShowPassword"
                  @click="isShowPassword = !isShowPassword"
                  class="material-icons mx-3 mt-3"
                >
                  lock_open
                </i>
                <i
                  v-else
                  @click="isShowPassword = !isShowPassword"
                  class="material-icons mx-3 mt-3"
                >
                  lock
                </i>
              </div>
            </div>
            <div class="w-full my-4">
              <div class="my-2">
                <label for="password">تکرار کلمه عبور:</label>
              </div>
              <div class="flex Password">
                <input
                  v-model="rePassword"
                  class="Password p-4 w-full"
                  :type="isShowRePassword ? 'text' : 'password'"
                  placeholder="کلمه عبور خود را تکرار کنید"
                  id="Password_input"
                />
                <i
                  v-if="isShowRePassword"
                  @click="isShowRePassword = !isShowRePassword"
                  class="material-icons mx-3 mt-3"
                >
                  lock_open
                </i>
                <i
                  v-else
                  @click="isShowRePassword = !isShowRePassword"
                  class="material-icons mx-3 mt-3"
                >
                  lock
                </i>
              </div>
            </div>
            <div v-if="!isCanSubmit" class="my-4 text-danger">
              **کلمه عبور و تکرار آن یکی نیستند.
            </div>
            <div class="flex">
              <a
                @click.prevent="submitForm()"
                class="w-full py-4 bg-success"
                style="border-radius: 0 0 40px 40px;text-align: center;color: white;cursor: pointer;"
                >ثبت‌نام</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import authService from "../../../auth/authService";
export default {
  data() {
    return {
      rePassword: "",
      password: "",
      model: {
        username: "",
        password: ""
      },
      isCanSubmit: true,
      isShowPassword: false,
      isShowRePassword: false
    };
  },
  methods: {
    async submitForm() {
      if (this.isCanSubmit && this.rePassword) {
        this.model.password = this.password;
        var access_token = await authService.getAccessToken();
        axios
          .post("https://userapi.avajang.com/api/Users/register", this.model, {
            headers: {
              Authorization: "Bearer" + " " + access_token
            }
          })
          .then(() => {
            this.loaded = true;
            this.$swal({
              position: "center-center",
              type: "success",
              text: "کاربر مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 3000
            });
          })
          .catch(e => {
            this.$swal({
              position: "center-center",
              type: "error",
              text: e.request.response,
              showConfirmButton: false,
              timer: 8000
            });
          });
      }
    }
  },
  watch: {
    rePassword() {
      if (this.rePassword === this.password) {
        this.isCanSubmit = true;
      } else {
        this.isCanSubmit = false;
      }
    },
    password() {
      if (this.rePassword === this.password) {
        this.isCanSubmit = true;
      } else {
        this.isCanSubmit = false;
      }
    }
  }
};
</script>
<style scoped>
.img-responsive {
  display: flex;
  margin: 1rem auto 2rem auto;
}
.wrapper {
  border-radius: 20px;
  border: 1px solid #cdd1d9;
  padding: 2rem;
}
.label_submit {
  border-radius: 40px 40px 0 0;
  text-align: center;
  color: black;
}
.Password {
  border-radius: 30px;
  border: 1px solid #007470;
  -webkit-box-shadow: inset 0 0 0 9999px #f1f8ff !important;
}
#Password_input {
  border: none;
}
input {
  font-size: 14px;
  font-family: "IRANSans", "IRANSans-Standard";
}
</style>
